import React from 'react';
import { Autocomplete, Box, Chip, TextField } from '@mui/material';
import { IOptionType, ThenFieldProps } from '../type';
import { sharedClasses } from '../../../../Components/CustomUIElements/sharedClasses';

/**
 * ThenField component handles the tag selection part of the auto tagging condition
 * It displays the "then" label and a MultiSelectWithCreate component for selecting tags
 * Users can select existing tags or create new ones on the fly
 */
const ThenField: React.FC<ThenFieldProps> = ({
  statusIndex,
  autoTagCondition,
  tags,
  handleChangeTags,
  isCreatingTag,
  handleCreateTag
}) => {
  // Handle both selecting existing tags and creating new ones
  const handleTagChange = (newValues: (string | IOptionType)[]) => {
    // Check if the last value is a string (new tag)
    if (typeof newValues[newValues.length - 1] === 'string') {
      // Create the new tag and pass the statusIndex
      handleCreateTag(newValues[newValues.length - 1] as string, statusIndex);
    } else {
      // Just selecting existing tags
      handleChangeTags(statusIndex, newValues as IOptionType[]);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 3 }}>
      <h4>then</h4>
      <Box sx={{ width: '290px' }}>
        <Autocomplete
          clearIcon={false}
          options={tags ? tags.map((tag) => ({ name: tag.label || tag.value, id: tag.id })) : []}
          getOptionLabel={(option) => option.name || ''}
          value={autoTagCondition.tags?.map((tag) => ({ name: tag.name, id: tag.id })) || []}
          onChange={(_, newValues) => {
            handleTagChange(newValues as IOptionType[]);
          }}
          multiple
          freeSolo
          loading={isCreatingTag}
          sx={sharedClasses.formAutocomplete}
          slotProps={{ listbox: { style: sharedClasses.autoCompleteListStyles } }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderTags={(value, props) =>
            value.map((option, index) => (
              <Chip label={option.name} {...props({ index })} key={index} />
            ))
          }
          renderOption={(props, option, state) => (
            <li
              {...props}
              key={option.id}
              style={{
                ...props.style,
                backgroundColor: state.selected ? '#e3f2fd' : undefined,
                fontWeight: state.selected ? 'bold' : undefined
              }}
            >
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField slotProps={{ inputLabel: { shrink: true } }} {...params} />
          )}
        />
      </Box>
    </Box>
  );
};

export default ThenField;
